export default {
  POST_REPORT_BUY_INQUIRY: "/api/v1/report-buy/inquiry",
  GET_REPORT_BUY_INQUIRY: "/api/v1/report-buy/inquiry",
  POST_REPORT_BUY_LOAN_CONSULTING_INQUIRY: "/api/v1/report-buy/inquiry/loan-consulting",
  GET_REPORT_BUY_LOAN_CONSULTING_INQUIRY: "/api/v1/report-buy/inquiry/loan-consulting",
  GET_REPORT_FILE_PRESIGNED_URL: "/api/v1/report/file", // + `/${fileSeq}/presigned-url`
  REPORT_QNA: "/api/v1/report-qna", // + `/${reportSeq}`
  // NZSC-3330 적정 매매가·적정 전세가 모듈
  GET_REPORT_VALUATION: "/api/v1/report", // + `/${reportSeq}/valuation` (리포트 소유자 인증)
  GET_REPORT_VALUATION_STATUS: "/api/v1/report/valuation-status", // 무인증 스위치 원값
  GET_REPORT_VALUATION_MANAGER_PREVIEW: "/api/v1/preview-report/manager/valuation", // 관리자 미리보기(NZSC-P-ENC 토큰, 소유자 기준 판정)
};
